import React from 'react';
import { DotIcon } from '@avila-tek/ui/src';

interface ActiveDotCellProps {
  active: boolean;
  text?: string;
}

function ActiveDotCell({ active, text }: ActiveDotCellProps) {
  return (
    <p className="flex gap-2 items-center capitalize ">
      <DotIcon
        className={` ${
          active ? 'text-success-300' : ' text-danger-200'
        } w-5 h-5`}
      />

      {text || (active ? 'Activo' : 'Desactivado')}
    </p>
  );
}

export default ActiveDotCell;
